export default __webpack_public_path__ + "static/media/The-Nut-Tree.57c8e64d.jpg";